import { render, staticRenderFns } from "./ItsSalesRegOutboundDetail.vue?vue&type=template&id=68ae4630&scoped=true&"
import script from "./ItsSalesRegOutboundDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesRegOutboundDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesRegOutboundDetail.vue?vue&type=style&index=0&id=68ae4630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae4630",
  null
  
)

export default component.exports